<ng-template #instructions><ng-content></ng-content></ng-template>
@if (this.Mode === 'design') {
  <div>
    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
      <mat-label>{{this.DisplayName}}</mat-label>
      <input matInput
        type="number"
        placeholder="{{this.PlaceholderText}}"
        value="{{this.PreviewModeValue}}"
        disabled />
      </mat-form-field>
      <ng-container *ngTemplateOutlet="instructions"></ng-container>
    </div>
  }

  @if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
    <div
      class="preview-instance-modes-div">
      <span class="preview-instance-modes-span">{{this.FormattedCalculatedValue}}</span>
      <ng-container *ngTemplateOutlet="instructions"></ng-container>
    </div>
  }
